// DataTable_ManageInvitations.js
import React, { useState } from 'react';
import { useTable, useGlobalFilter, useSortBy, usePagination } from 'react-table';
import ReactPaginate from 'react-paginate';
import './Forms.css';

export const DataTable_ManageInvitations = ({ data, columns, searchField, height, stickyColumns = 0 }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filterInput, setFilterInput] = useState("");

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilterInput(value);
    setGlobalFilter(value);
  };

  const handlePageClick = data => {
    const selected = data.selected;
    setCurrentPage(selected);
    gotoPage(selected);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    gotoPage,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns: columns, // Gebruik de originele kolomdefinities
      data,
      initialState: { pageIndex: 0, pageSize: 100 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize } = state;
  const totalFilteredRecords = rows.length;
  const startItem = totalFilteredRecords === 0 ? 0 : pageIndex * pageSize + 1;
  const endItem = Math.min(startItem + pageSize - 1, totalFilteredRecords);
  const paginationText = `${startItem} - ${endItem} van ${totalFilteredRecords}`;

  // Als er slechts één rij op de pagina staat, gebruik "auto" voor de hoogte
  const containerStyle = {
    width: '100%',
    overflowX: 'auto',
    height: page.length === 1 ? 'auto' : height,
  };

  return (
    <>
      {searchField && (
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <input
            type="text"
            value={filterInput}
            onChange={handleFilterChange}
            placeholder="Search..."
            style={{ width: '200px' }}
          />
        </div>
      )}
      <div className="CP_table-container" style={{ width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div className="CP_table-container" style={{ width: '100%', display: 'flex', flexDirection: 'column', overflow: 'auto'}}>
          <table
            {...getTableProps()}
            style={{
              borderCollapse: 'separate',  // in plaats van 'collapse'
              borderSpacing: 0,              // geen extra ruimte tussen cellen
              minWidth: '100%'
            }}
          >
            <thead style={{ position: 'sticky', top: 0, background: '#eee' }}>
              {headerGroups.map((headerGroup, headerGroupIndex) => (
                <tr key={`header-group-${headerGroupIndex}`} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, columnIndex) => (
                    <th
                      key={`header-${columnIndex}`}
                      {...column.getHeaderProps()}
                      style={{
                        padding: '10px',
                        borderBottom: '1px solid #ddd',
                        // Als de kolom de e-mailkolom betreft, links uitlijnen, anders centreren
                        textAlign: column.id === 'user_email' ? 'left' : 'center',
                        background: '#fff',
                        minWidth: '150px',
                        // Verticale randen
                        borderLeft: '1px solid black',
                        borderRight: '1px solid black',
                        position: columnIndex < stickyColumns ? 'sticky' : 'static',
                        left: columnIndex < stickyColumns ? `${columnIndex * 150}px` : 'auto',
                        zIndex: columnIndex < stickyColumns ? 20 : 1,
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', padding: 0, margin: 0 }}>
                        <div
                          {...column.getSortByToggleProps()}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            alignItems: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: column.id === 'user_email' ? 'flex-start' : 'flex-start' 
                          }}>
                            <span>{column.render('Header')}</span>
                            {column.id !== 'user_email' && (
                              <span style={{ 
                                fontSize: '0.8em', 
                                fontStyle: 'italic', 
                                fontWeight: 'normal', 
                                textAlign: 'left', 
                                marginTop: '2px' 
                              }}>
                                {(typeof column.id === 'string' && column.id.includes('_layout_'))
                                  ? 'Form'
                                  : 'Module'}
                              </span>
                            )}
                          </div>
                          {column.id !== 'user_email' && column.headerPopup && (
                            <div
                              onClick={e => {
                                e.stopPropagation();
                                column.headerPopup();
                              }}
                              style={{ marginLeft: '10px', cursor: 'pointer' }}
                            >
                              <span>🔍</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                const rowIndex = pageIndex * pageSize + index;
                return (
                  <tr key={`row-${rowIndex}`} {...row.getRowProps()}>
                    {row.cells.map((cell, cellIndex) => (
                      <td
                        key={`cell-${rowIndex}-${cellIndex}`}
                        {...cell.getCellProps()}
                        style={{
                          padding: '8px',
                          borderBottom: '1px solid #ddd',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          minWidth: '150px',
                          // Als de cel uit de e-mailkolom komt: links, anders gecentreerd
                          textAlign: cell.column.id === 'user_email' ? 'left' : 'center',
                          // Verticale randen voor elke cel:
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          position: cellIndex < stickyColumns ? 'sticky' : 'static',
                          left: cellIndex < stickyColumns ? `${cellIndex * 150}px` : 'auto',
                          background: cellIndex < stickyColumns ? '#fff' : 'inherit',
                        }}
                        title={cell.value}
                      >
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}></div>
      <div className="CP_footer-container" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '50px' }}>
        <span className="CP_footer-info" style={{ width: '150px', textAlign: 'left' }}>{paginationText}</span>
        <span className="CP_footer-info" style={{ width: '100%' }}></span>
        <div className="CP_footer-info" style={{ width: '150px', textAlign: 'right', display: 'flex' }}>
          <ReactPaginate
            previousLabel={<i className="fas fa-arrow-left" style={{ cursor: 'pointer' }}></i>}
            nextLabel={<i className="fas fa-arrow-right" style={{ cursor: 'pointer' }}></i>}
            breakLabel={'...'}
            pageCount={Math.ceil(totalFilteredRecords / pageSize)}
            onPageChange={({ selected }) => gotoPage(selected)}
            containerClassName={'CP_footer-pagination'}
            activeClassName={'active'}
          />
        </div>
      </div>
    </>
  );
};
